// @ts-expect-error FireAlarmUi is untyped
import FireAlarmApp from 'FireAlarmUi/js/FireAlarmApp';
export const startFireAlarm = () => {
  // displays firealarm at top of page if one exists
  const config = {
    appName: 'LearningCenterUI',
    containers: {
      default: {
        before: document.querySelector('#learning-center-ui-root')
      }
    }
  };
  const fireAlarm = new FireAlarmApp(window.hubspot, config);

  // @ts-expect-error FireAlarmUi is untyped
  window.hubspot[FireAlarmApp.HUBSPOT_FIREALARM_KEY] = fireAlarm;
  fireAlarm.start();
};